const CDN = "https://cdn.prod.website-files.com";

export const asset = {
  navLogo: `${CDN}/6927611bf52c8158c12e668a/69288ce8bbd03d8dc9d14cd6_navLogo.svg`,
  footerLogo: `${CDN}/6927611bf52c8158c12e668a/692de4ee66cc7199d87daf03_638a953f56690098c56fd76552f058b7_footerLogo.svg`,
  buttonArrow: `${CDN}/6927611bf52c8158c12e668a/693b437b53facf31526624df_buttonArrow.svg`,
  topArrow: `${CDN}/6927611bf52c8158c12e668a/692dcbb715c16b99bef28212_topArrow.svg`,
  listCheck: `${CDN}/6927611bf52c8158c12e668a/6929cd225b3fb3f396a29a2a_listCheck.svg`,
  teamPhoto: `${CDN}/6927611bf52c8158c12e668a/69612d79c60b521d6e306789_section-1.webp`,
  heroIconOne: `${CDN}/6929c116366a14507fc8424d/692a5717d933cf4874e317d1_hero%20icon%20one.webp`,
  heroIconThree: `${CDN}/6929c116366a14507fc8424d/692a5717d933cf4874e317ce_hero%20icon%20three.webp`,
  linkedin: `${CDN}/6927611bf52c8158c12e668a/692de7dd1d89e98535ea5cf0_f64654ab4574e43b53013d70436129e1_linkedinIcon.svg`,
  instagram: `${CDN}/6927611bf52c8158c12e668a/692de7dd7d01a2bef7146499_117e9d34adbd7f8d3ef3d35e15a6fb67_instagramIcon.svg`,
  x: `${CDN}/6927611bf52c8158c12e668a/692de7dd2be80106a7cd4c1d_6bd7f2b4e36440be9ff95297776e9e31_xIcon.svg`,
};

export type Member = { name: string; photo: string; flag: string };

const M = `${CDN}/6927611bf52c8158c12e66b6`;

export const members: Member[] = [
  { name: "Sales Executive", photo: `${M}/692e1f0e47c3407d973f1840_loopMember01.webp`, flag: `${M}/692e20009493dc69e663cedc_flag01.png` },
  { name: "Account Executive", photo: `${M}/692e2099c4464a0f64771ae2_loopMember02.webp`, flag: `${M}/692e209c9a85cd84493e4cdb_flag02.png` },
  { name: "SDR", photo: `${M}/692e20b0ee59d2b908f85cb3_loopMember03.webp`, flag: `${M}/692e20b3d002929b4d74424a_flag03.png` },
  { name: "BDR", photo: `${M}/692e20c1a1b598b39a01562b_loopMember04.webp`, flag: `${M}/692e20c64d757b249900601b_flag04.png` },
  { name: "Appointment Setter", photo: `${M}/692e213f1df873e541b4597a_loopMember05.webp`, flag: `${M}/692e214291a0b467a31e23e8_flag05.png` },
  { name: "Sales Manager", photo: `${M}/692e215157fa68ff1845aae0_loopMember06.webp`, flag: `${M}/692e21564990ae565c324788_flag06.png` },
  { name: "Inside Sales", photo: `${M}/692e216a664800e679d504be_loopMember07.webp`, flag: `${M}/692e216d18d065443351880f_flag07.png` },
  { name: "Recruitment Consultant", photo: `${M}/692e218d18d0654433518c23_loopMember08.webp`, flag: `${M}/692e21926e605445e15ff0e3_flag08.png` },
];

export const services = [
  {
    title: "01. Post your role",
    text: "Tell sales professionals exactly what you\u2019re hiring for. Free to post.",
    icon: `${M}/692e347c4d029f69c7712ebf_serviceOne.svg`,
    bg: "bg-mint-soft",
  },
  {
    title: "02. Candidates pitch themselves",
    text: "Instead of another generic application, candidates record a short pitch on why they\u2019re right for the role.",
    icon: `${M}/692e348f9e3a18e2c86b7921_serviceTwo.svg`,
    bg: "bg-purple-soft",
  },
  {
    title: "03. Listen and shortlist",
    text: "Hear candidates before wasting time interviewing them. Find who\u2019s worth speaking to in minutes, not days.",
    icon: `${M}/692e349742854f2653765598_serviceThree.svg`,
    bg: "bg-orange-soft",
  },
];

export const benefits = [
  {
    title: "Less screening",
    text: "Stop reading applications from people you\u2019ll never interview.",
    icon: `${CDN}/6927611bf52c8158c12e668a/6928f353c2290cf08871ed1a_e47e54edc11857ffd08b457e10844c2d_benefitsOne.svg`,
  },
  {
    title: "Better signal",
    text: "Hear communication style, confidence, and sales ability before the first interview.",
    icon: `${CDN}/6927611bf52c8158c12e668a/6928f353c2aefcbcc0077a48_717475ae66024152e3b3a9b8aa97b3c2_benefitsTwo.svg`,
  },
  {
    title: "Faster hiring",
    text: "Build a shortlist in minutes instead of days.",
    icon: `${CDN}/6927611bf52c8158c12e668a/6928f353e016921b2a8ded74_b092438b7da2fdac21f2a00d1c2fc116_benefitsThree.svg`,
  },
  {
    title: "Free to start",
    text: "Post your first role at no cost.",
    icon: `${CDN}/6927611bf52c8158c12e668a/6928f3533ef1763c3e777475_d33e5f456f4bdf9f0e2d4d650c61b075_benefitsFour.svg`,
  },
];

export const compareCards = [
  {
    label: "The old way",
    title: "",
    text: "200 applications \u2192 Open 200 CVs \u2192 Guess who can sell \u2192 Email candidates \u2192 Book interviews \u2192 Run first round calls \u2192 Discover half can\u2019t sell \u2192 Start again",
    bg: "bg-beige",
    rotate: "-rotate-3",
  },
  {
    label: "The Closdd way",
    title: "",
    text: "200 applications \u2192 Candidates pitch themselves \u2192 Listen to the strongest \u2192 Shortlist \u2192 Interview \u2192 Hire",
    bg: "bg-mint-soft",
    rotate: "rotate-2",
  },
  {
    label: "Know in 10 seconds, not 10 days.",
    title: "",
    text: "A CV can tell you where someone worked. It can\u2019t tell you how they sound, whether they can build rapport, or whether they\u2019d be any good on the phone with your customers.\n\nSo hear them.",
    bg: "bg-orange-soft",
    rotate: "-rotate-2",
  },
  {
    label: "Built for people who actually sell.",
    title: "",
    text: "Closdd is built specifically for sales hiring: sales executives, account executives, SDRs, BDRs, appointment setters, business development reps, recruitment consultants, sales managers, inside sales teams.\n\nYou don\u2019t need another job board. You need a better way to identify sales talent.",
    bg: "bg-purple-soft",
    rotate: "rotate-3",
  },
];

export const whyPoints = [
  {
    text: "You post a sales role. 200 people apply.",
  },
  {
    text: "Then you open CV after CV, chase candidates, book interviews, sit through first round calls, only to discover half of them can\u2019t hold a conversation, handle an objection, or confidently pitch an offer.",
  },
  {
    text: "By the time you find out, you\u2019ve wasted days, sometimes weeks.",
  },
  {
    text: "Closdd changes the first step. Instead of asking \u201cdoes this CV look good?\u201d you can ask \u201ccan this person actually sell?\u201d",
  },
];

export const faqs = [
  {
    q: "Is it free to post a job?",
    a: "Yes. Post your sales role and start receiving applications at no cost.",
  },
  {
    q: "Do candidates still need a CV?",
    a: "Candidates can add their experience and background, but the key difference is you hear them pitch themselves before deciding whether to interview.",
  },
  {
    q: "How long should the pitch be?",
    a: "60 seconds. That is long enough to show how someone speaks and handles themselves, and short enough to listen to a whole shortlist in minutes.",
  },
  {
    q: "What type of sales roles can I post?",
    a: "Any sales role: sales executives, account executives, SDRs, BDRs, appointment setters, business development reps, recruitment consultants, sales managers and inside sales, plus closers and other phone-based roles.",
  },
  {
    q: "Why not just use a normal job board?",
    a: "Normal job boards are built around CVs because that\u2019s what they were designed to screen. They weren\u2019t built for sales, where the job is a conversation, not a document. A CV can\u2019t show you tone, pace, or whether someone can hold a call. A 60-second pitch can, before you\u2019ve spent a minute of your own time. Closdd lets you hear communication style, confidence and sales ability before the first interview, so you shortlist in minutes instead of days.",
  },
];

export const footerLinks: { label: string; to: string }[] = [
  { label: "Find jobs", to: "/find-jobs" },
  { label: "For employers", to: "/for-employers" },
  { label: "For salespeople", to: "/for-salespeople" },
  { label: "How it works", to: "/how-it-works" },
  { label: "Sectors", to: "/sectors" },
  { label: "Appointment setting", to: "/appointment-setting" },
  { label: "Sales training", to: "/sales-training" },
  { label: "Academy", to: "/academy" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
  { label: "Log in", to: "/login" },
];
